import './App.css';
import React, { Component } from 'react';
import dashboard from './pages/components/Dashboard/dashboard';
import Property from './pages/components/Dashboard/pages/property/property';
import SignIn from './pages/components/Auth/sign_in/sign_in';
import SignUp from './pages/components/Auth/sign_up/sign_up';
import VerifySignIn from './pages/components/Auth/sign_in/verify_sign';
import ForgetPassword from './pages/components/Auth/forget_password/forgret_password';
import AddEstate from './pages/components/Dashboard/pages/estate/addEstate';
import Resident from './pages/components/Dashboard/pages/resident/resident';
import Guests from './pages/components/Dashboard/pages/guests/guests';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'; 
import { setContext } from '@apollo/client/link/context';
import {
  ApolloClient,
  InMemoryCache,
  ApolloProvider,
  HttpLink,
  from,
} from "@apollo/client";
import { onError } from "@apollo/client/link/error";
import AuthProvider from './context/AuthContext';
import Dues from './pages/components/Dashboard/pages/dues/dues';
import DuesOne from './pages/components/Dashboard/pages/dues/duesOne';
import Settings from './pages/components/Dashboard/pages/settings/settings';
import ActivateAccount from './pages/components/Auth/sign_up/activate_account';
import Cookies from 'js-cookie';
import LoadingPage from './pages/components/loading_page';
import Communication from './pages/components/Dashboard/pages/communications/communication';
import Security from './pages/components/Dashboard/pages/security/security';
import CommunicationOne from './pages/components/Dashboard/pages/communications/communicationOne';
import AddCommunication from './pages/components/Dashboard/pages/communications/addComm';
import BankIntegration from './pages/components/Dashboard/pages/bankIntegration/bankIntegration';
import PageLoader from './pages/components/Dashboard/pages/page_loader';
import Payment from './pages/components/Dashboard/pages/payment/payment';
import MakePayment from './pages/components/Dashboard/pages/payment/makePayment';
import ResetPassword from './pages/components/Auth/reset_password/reset_password';
import ComplaintById from './pages/components/Dashboard/pages/complaints/complaintsById';
import Owner from './pages/components/Dashboard/pages/owner/owner';
import DuesSpecific from './pages/components/Dashboard/pages/dues/duesSpecific';
import PropertyPageReceivableByIdWidget from './pages/components/Dashboard/pages/property/receivablesDetails';
import PaySuccess from './pages/components/Dashboard/pages/paySuccess';
import AddAssets from './pages/components/Dashboard/pages/estate/addAssets';
import ListEstateAssets from './pages/components/Dashboard/pages/estate/listEstate';
import Complaints from './pages/components/Dashboard/pages/complaints/complaints';
import Homebycalendar from './pages/components/Dashboard/pages/home/homebycalendar';
import SubAdmin from './pages/components/Dashboard/pages/sub-admin/sub-admin';

const errorLink = onError(({ graphqlErrors, networkError }) => {
  if (graphqlErrors) {
    // graphqlErrors.map(({ message, location, path }) => {
    //   alert(`Graphql error ${message}`);
    // });
  }
});

const authLink = setContext((_, { headers }) => {
  const accessToken = Cookies.get('userAccessToken');

  return {
    headers: {
      ...headers,
      Authorization: accessToken ? `Bearer ${accessToken}` : '',
    },
  };
});

const link = from([
  errorLink,
  new HttpLink({ uri: process.env.REACT_APP_API_URL}),
]);

const client = new ApolloClient({
  cache: new InMemoryCache(),
  link: authLink.concat(link),
});

export default class App extends Component {
  render() {
    return (
      <ApolloProvider client={client}>
        <Router> 
          <AuthProvider>
            <Switch>
              {/* auth */}
              <Route exact path="/" component={SignIn} />
              <Route path="/verifySignIn/:id" component={VerifySignIn} />
              <Route path="/signup" component={SignUp} />
              <Route path="/signUpActivateAccount/:id" component={ActivateAccount} />
              <Route path="/forgetPassword" component={ForgetPassword} />
              <Route path="/reset-password/:id" component={ResetPassword} />
              <Route path="/loadingPage" component={LoadingPage} />
              <Route path="/loader" component={PageLoader} />
              {/* dashboard pages */}
              <Route path="/dashboard" component={dashboard} />
              <Route path="/listEstates" component={ListEstateAssets} />
              <Route path="/addAssets" component={AddAssets} />
              <Route path="/property" component={Property} />
              <Route path="/addEstate" component={AddEstate} />
              <Route path="/resident" component={Resident} />
              <Route path="/guests" component={Guests} />
              <Route path="/dues" component={Dues} />
              <Route path="/duesOne/:id" component={DuesOne} />
              <Route path="/duesSpecific" component={DuesSpecific} />
              <Route path="/settings" component={Settings} />
              <Route path="/addCommunication" component={AddCommunication} />
              <Route path="/communication" component={Communication} />
              <Route path="/communicationOne/:id" component={CommunicationOne} />
              <Route path="/security" component={Security} />
              <Route path="/banks" component={BankIntegration} />
              <Route path="/payment" component={Payment} />
              <Route path="/makePayment" component={MakePayment} />
              <Route path='/complaintById/:id' component={ComplaintById} />
              <Route path='/complaints/:id' component={ComplaintById} />
              <Route path='/property' component={Property} />
              <Route path='/complaint' component={Complaints} />
              <Route path='/owner' component={Owner} />
              <Route path="/receivablesById/:id" component={PropertyPageReceivableByIdWidget} />
              <Route path="/paySucces" component={PaySuccess} />
              <Route path="/homeByDate/:id" component={Homebycalendar} />
              <Route path='/sub-admin' component={SubAdmin} />
            </Switch>
          </AuthProvider>
        </Router>
      </ApolloProvider>
    );
  }
}




